import { getRouteExp } from './getRouteExp';
import { IRoute } from './IRoute';
import { IRouteProps } from './IRouteProps';
import { matchRoute } from './matchRoute';

export function getRoute(props: IRouteProps): IRoute {
  if (!props.path)
    throw new Error('path is required');

  const pathExp = getRouteExp(props.path);

  const match = matchRoute(
    location.pathname + location.search, pathExp);

  return {
    id: props.name ?? props.path,
    pathExp,
    match,
    render: props.render
  } as any;
}
